import React, { useEffect, useState } from 'react';
import axios from 'axios';

const NamesList = () => {
  const [names, setNames] = useState([]);

  useEffect(() => {
    const fetchNames = async () => {
      try {
        const apiUrl = `https://kodedudes.com/api/names`; // Use the same origin as the frontend
        const response = await axios.get(apiUrl);
        setNames(response.data);
      } catch (error) {
        console.error('Error fetching names:', error);
      }
    };

    fetchNames();
  }, []);

  return (
    <div>
      <h1>List of Names</h1>
      <ul>
        {names.map((name, index) => (
          <li key={index}>{name}</li>
        ))}
      </ul>
    </div>
  );
};

export default NamesList;